export class Utils {
  public static deepCopy<T>(
    source: T,
    nullStrategy: (key: string, value: any) => any = this.replaceNullWithEmptyStringStrategy): T {
    const stringify = nullStrategy
      ? JSON.stringify(source, nullStrategy)
      : JSON.stringify(source);

    return JSON.parse(stringify);
  }

  public static replaceNullWithEmptyStringStrategy(key: string, value: any): any {
    return value === null ? '' : value;
  }

  public static isJsonDirty(object1: any, object2: any, nullStrategy: (key: string, value: any) => any = null) {
    if (!nullStrategy) {
      nullStrategy = Utils.replaceNullWithEmptyStringStrategy;
    }

    const json1 = JSON.stringify(object1, nullStrategy);
    const json2 = JSON.stringify(object2, nullStrategy);

    return json1 !== json2;
  }
}
